export default __webpack_public_path__ + "static/media/bg_loading_desktop.a25d65eb.jpg";